<ng-container *ifScreenSize="screenSize.Desktop">
  @if (isKid) {
  <div class="bg-primary pb-3">
    <div class="container">
      <img
        class="kids-banner w-100"
        [src]="
          memberInfo.kidType == KidType.AllStars
            ? ('banners/welcome-banner-allstars.png' | contentAssetImage)
            : memberInfo.kidType == KidType.Junior
            ? ('banners/welcome-banner-baller.png' | contentAssetImage)
            : null
        "
      />
    </div>
  </div>
  } @else if (isClub1901) {
  <div class="club-banner-bg pb-3">
    <div class="container">
      <img class="club1901-banner w-100" [src]="'1901/1901-welcome.png' | contentAssetImage" />
    </div>
  </div>
  } @else if (isSTHMember) {
  <div class="banner" role="banner" [style.backgroundImage]="'url(' + ('banners/banner.png' | contentAssetImage) + ')'">
    <div class="container d-flex align-items-center justify-content-center">
      <div class="member-details text-center">
        <h1>{{ 'home.page.title' | translate }} {{ memberInfo.firstName }}</h1>
      </div>
    </div>
  </div>
  }
</ng-container>
